// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mc-6";
export var imgContainer = "_mc-3";
export var menuIcon = "_mc-5";
export var pillWrapper = "_mc-2";
export var pillsContainer = "_mc-1";
export var subscriptionCard = "_mc-0";
export var subscriptionLogo = "_mc-4";